export const GET_GOVERNORATES_REQUEST = 'GET_GOVERNORATES_REQUEST'
export const GET_GOVERNORATES = 'GET_GOVERNORATES'
export const GET_GOVERNORATES_REQUEST_PENDING = 'GET_GOVERNORATES_REQUEST_PENDING'
export const GET_GOVERNORATES_REQUEST_SUCCESS = 'GET_GOVERNORATES_REQUEST_SUCCESS'
export const GET_GOVERNORATES_REQUEST_ERROR = 'GET_GOVERNORATES_REQUEST_ERROR'
export const PULL_GOVERNORATES_REQUEST = 'PULL_GOVERNORATES_REQUEST'

